import RecentInvoicePageBody from '../components/recentInvoicePage/RecentInvoicePageBody'

const RecentInvoice = () => {
  return (
    <RecentInvoicePageBody/>
  )
}

export default RecentInvoice